import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledBoxContainerContent = styled(Box)(({ theme }) => ({
  padding: '1rem',
  width: '100%',
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
}))

export const StyledBoxContainerTitle = styled(Box)(({ theme }) => ({
  borderBottom: '2px solid',
  borderColor: theme.palette.primary.main,
}))

export const StyledNumeroProcesso = styled('span')(() => ({
  cursor: 'pointer',
  ':hover': { textDecoration: 'underline' },
}))

export const StyledBoxTitle = styled(Box)(({ theme }) => ({
  borderBottom: '2px solid',
  borderColor: theme.palette.primary.main,
  marginBottom: theme.spacing(4),
}))
